<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''"></h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="md" @click="openCreateModal()">Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="pushNotifications"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Message</th>
          <!--<th class="text-center">To</th>-->
          <th class="text-center">Pushed Date</th>
          <!-- <th class="text-center">Actions</th> -->
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.message}}</span>
              </div>
            </div>
          </td>
          <!--<td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.recipient}}</span>
              </div>
            </div>
          </td>-->
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.pushed_date}}</span>
              </div>
            </div>
          </td>

          <!-- <td class="text-center">
            <base-dropdown class="dropdown"
                           position="center">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#" @click="">Update</a>
              </template>
            </base-dropdown>
          </td>-->
        </template>
      </base-table>
    </div>

    <div class="row" id="div-create-industry-modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.create_push_notification_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">CREATE NEW ANNOUNCEMENT</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Title:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        id="title"
                        rows="3"
                        placeholder="Title"
                        v-model="newPushNotification.title"
                      ></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Message:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        id="message"
                        rows="3"
                        placeholder="Message"
                        v-model="newPushNotification.message"
                      ></textarea>
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.create_push_notification_modal = false"
                    >Cancel</base-button>
                    <base-button
                      type="success"
                      class="my-4"
                      @click="createPushNotification()"
                    >Push Now</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalPushNotification" :value="pageNumber"></base-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "push-notifications-table",
  props: {
    type: {
      type: String
    },
    title: String
  },
  data() {
    return {
      totalPushNotification: 0,
      show: false,
      message: "",
      newPushNotification: {
        title: "",
        message: ""
      },
      modals: {
        create_push_notification_modal: false
      }
    };
  },
  computed: {
    pushNotifications() {
      return this.$store.getters.pushNotifications;
    },
    pageNumber() {
      return parseInt(this.$route.query.page);
    },
    totalPushNotifications() {
      return this.totalPushNotification;
    }
  },
  watch: {
    pageNumber() {
      this.getPushNotifications(this.$route.query.page);
    }
  },
  mounted() {
    this.getPushNotifications(1);
    this.getTotalPushNotifications();
  },
  methods: {
    getPushNotifications: function(page_number) {
      this.$store
        .dispatch("fetchPushNotifications", page_number)
        .then(response => {
          this.$store.dispatch("updateState", {
            key: "pushNotifications",
            value: response.data
          });
        });
    },

    getTotalPushNotifications() {
      this.$store.dispatch("fetchTotalPushNotification").then(response => {
        this.totalIndustry = parseInt(response.data);
      });
    },

    createPushNotification() {
      this.$store
        .dispatch("createPushNotification", {
          title: this.newPushNotification.title,
          message: this.newPushNotification.message
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.modals.create_push_notification_modal = false;
            this.getPushNotifications(this.$route.query.page);
            this.getTotalPushNotifications();
          } else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    openCreateModal: function() {
      this.modals.create_push_notification_modal = true;
      this.show = false;
      this.message = "";
      this.newPushNotification.title = "";
      this.newPushNotification.message = "";
    }
  }
};
</script>
<style>
</style>
